import { Divider, List } from '@mui/material';
import { useEffect, useState } from 'react';

import EntityLinks from './EntityLinks';
import { fetchJsonWithAuth, fetchWithAuth } from './fetch-json.util';
import { EditEntityModal } from './EditEntityModal';
import SMModal from './SMModal';

export function EntityLinksList(props) {
  const {
    entityName,
    entityData,
    userInfoMap,
    isEdit,
    dispatch,
    apiUrl,
    setEntityToDelete,
    entityToDelete,
    showHideEnabled,
    doNotShowPhaseTags,
    enqueueToast,
    handleEntityUpdateLogic,
    deleteHandler
  } = props;
  const {
    setStatusErrorMsg,
    incrementAPIInProgress,
    decrementAPIInProgress,
    clearAllMessages,
    setStatusSuccessMsg
  } = props.commonProps;

  const [showModalDelete, setShowModalDelete] = useState(false);
  const [entityToEdit, setEntityToEdit] = useState(null);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const handleModalDeleteCancel = () => setShowModalDelete(false);
  const entityLabel = entityName.charAt(0).toUpperCase() + entityName.slice(1);

  useEffect(() => {
    if (entityData && dispatch) {
      dispatch({ type: 'FETCH_SUCCESS', payload: entityData });
    }
  }, [entityData]);

  function openEntity(e, entity) {
    e.preventDefault();
    incrementAPIInProgress();
    fetchJsonWithAuth(`${apiUrl}/${entity?.number ?? entity?.templateId}`, {
      method: 'GET'
    })
      .then((response) => {
        if (response.meta.status === 200) window.open(response.json.path, '');
        else if (response.meta.status === 400 || response.meta.status === 404)
          setStatusErrorMsg('Bad Request!');
      })
      .catch((error) =>
        setStatusErrorMsg(
          `Couldn't fetch the ${entityName}. Please try again.`,
          error
        )
      )
      .finally(() => decrementAPIInProgress());
  }

  const handleShowHide = (e, entity) => {
    clearAllMessages();
    incrementAPIInProgress();
    const entityToUpdate = {
      ...entity,
      visibleOnSummary: !entity?.visibleOnSummary
    };

    const body = JSON.stringify(entityToUpdate);

    handleEntityUpdateLogic
      ? handleEntityUpdateLogic(entityToUpdate)
      : fetchJsonWithAuth(`${apiUrl}/${entity.number || entity.commentId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          body
        })
          .then((response) => {
            if (response.meta.status === 200)
              dispatch({ type: 'edit', payload: response.json });
            else
              setStatusErrorMsg(
                `Couldn't update the ${entityName}. Please try again.`
              );
          })
          .catch((error) =>
            setStatusErrorMsg(
              `Couldn't update the ${entityName}. Please try again.`,
              error
            )
          )
          .finally(() => decrementAPIInProgress());
  };

  function editEntity(e, entity) {
    e.preventDefault();
    setShowModalEdit(true);
    setEntityToEdit(entity);
  }

  const handleModalEditCancel = () => {
    setShowModalEdit(false);
  };

  function removeEntity(e, entity) {
    e.preventDefault();
    setShowModalDelete(true);
    setEntityToDelete(entity);
  }

  const AttachListComp = ({ showScrollBar }) => {
    return (
      <List disablePadding={true}>
        {entityData?.map((item, index) => (
          <>
            <EntityLinks
              key={item.number}
              entityName={entityName}
              commonProps={props.commonProps}
              removeEntity={removeEntity}
              editEntity={editEntity}
              openEntity={openEntity}
              entity={item}
              userInfoMap={userInfoMap}
              readOnly={!isEdit}
              showHideEnabled={showHideEnabled}
              handleShowHide={handleShowHide}
              doNotShowPhaseTags={doNotShowPhaseTags}
            />
            {index !== entityData.length - 1 && <Divider />}
          </>
        ))}
      </List>
    );
  };

  function handleModalDeleteYes(e) {
    e.preventDefault();
    setShowModalDelete(false);
    clearAllMessages();

    incrementAPIInProgress();

    const deleteUrl = `${apiUrl}/${
      entityToDelete?.number ?? entityToDelete?.templateId
    }`;

    deleteHandler
      ? deleteHandler(entityToDelete)
      : fetchWithAuth(deleteUrl, {
          method: 'DELETE'
        })
          .then((response) => {
            if (response?.status === 200) {
              if (enqueueToast) {
                enqueueToast({
                  variant: 'success',
                  message: `${entityName} has been successfully deleted.`
                });
              } else {
                setStatusSuccessMsg(
                  `${entityName} has been successfully deleted.`
                );
              }
              dispatch({ type: 'del', payload: entityToDelete });
            } else if (response?.status === 400 || response?.status === 404)
              setStatusErrorMsg('Bad Request!');
          })
          .catch((error) =>
            setStatusErrorMsg(
              `Couldn't delete the ${entityName}. Please try again.`,
              error
            )
          )
          .finally(() => decrementAPIInProgress());
  }

  return (
    <>
      <AttachListComp showScrollBar={true} />
      {showModalEdit && entityToEdit && (
        <EditEntityModal
          showModal={showModalEdit}
          handleCancel={handleModalEditCancel}
          entityToEdit={entityToEdit}
          dispatch={dispatch}
          setEntityToEdit={setEntityToEdit}
          handleEntityUpdateLogic={handleEntityUpdateLogic}
          entityName={entityLabel}
          url={`${apiUrl}/${entityToEdit?.number ?? entityToEdit?.templateId}`}
          entityType={
            entityToEdit?.commentId
              ? 'comment'
              : entityToEdit?.linkId
                ? 'link'
                : 'attachment'
          }
        />
      )}
      <SMModal
        showModal={showModalDelete}
        handleCancel={handleModalDeleteCancel}
        handleYes={handleModalDeleteYes}
        title={`Delete ${entityLabel}`}
        msg_line1={`Are you sure you want to delete this ${entityLabel}?`}
        msg_line2=""
        cancelText="Cancel"
        yesText={`Delete ${entityLabel}`}
        id={entityToDelete}
      />
    </>
  );
}
